import { createContext, useContext, useEffect, useState } from "react";
import adminApi from "../lib/adminApi";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=loading, false=guest, object=admin

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (!token) { setAdmin(false); return; }
    adminApi.get("/auth/me")
      .then((r) => {
        if (r.data?.role === "admin") setAdmin(r.data);
        else { localStorage.removeItem("admin_token"); setAdmin(false); }
      })
      .catch(() => { localStorage.removeItem("admin_token"); setAdmin(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem("admin_token", data.token);
    const me = await adminApi.get("/auth/me");
    if (me.data?.role !== "admin") {
      localStorage.removeItem("admin_token");
      throw new Error("Этот аккаунт не имеет прав администратора");
    }
    setAdmin(me.data);
    return me.data;
  };

  const logout = () => { localStorage.removeItem("admin_token"); setAdmin(false); };

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
